// extracted by mini-css-extract-plugin
export default {"teamLogo":"AdvisorProfileTeamCard_teamLogo__jjA7E"};